/* eslint-disable vue/valid-v-bind */
<template>
  <div>
    <b-card title="Refund Over-All Transaction">
      <b-row class="mb-1">
        <!-- search input -->
        <b-col>
          <section>
            <b-button
              v-b-modal.modal-filter-orders
              variant="outline-primary"
              class="d-flex"
            >
              <feather-icon icon="FilterIcon" />Filter
            </b-button>
          </section>
        </b-col>
        <b-col>
          <b-form-group
            v-if="dataFiltered == true"
            class="d-flex justify-content-center"
          >
            <!-- search input -->
            <div>
              <b-form-input
                v-model="searchTerm"
                type="search"
                placeholder="search"
              />
            </div>
          </b-form-group>
        </b-col>

        <b-col v-if="dataFiltered === true" class="d-flex justify-content-end">
          <xlsx-workbook>
            <xlsx-sheet
              v-for="sheet in sheets"
              :key="sheet.name"
              :collection="sheet.data"
              :sheet-name="sheet.name"
            />
            <xlsx-download>
              <b-button variant="primary" class="d-flex">
                <feather-icon icon="DownloadCloudIcon" /> Export
              </b-button>
            </xlsx-download>
          </xlsx-workbook>
        </b-col>
      </b-row>
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Name -->
          <span v-if="props.column.field === 'refundFOP'">
            <span>
              {{
                paymentOptions.filter((f) => f.value == props.row.refundFOP)[0]
                  .text
              }}
            </span>
          </span>
          <b-link
            v-else-if="props.column.field === 'refundReferenceCode'"
            :to="{
              name: 'refundRequest-details',
              params: {
                id: props.row.id,
              },
            }"
            target="_blank"
          >
            <feather-icon icon="EyeIcon" />
            <span class="align-middle ml-50">{{
              props.row.refundReferenceCode
            }}</span>
          </b-link>
          <!-- <span
            v-if="props.column.field === 'orderId'"
            class="text-nowrap"
          >
            <span class="text-nowrap">{{ props.row.orderId }}</span>
          </span> -->

          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'action'">
            <span>
              <b-row v-if="props.row.paymentStatus !== 3">
                <!-- v-else-if="props.row.Payment_Status==='pending'" -->
                <b-dropdown
                  variant="link"
                  class="m-4"
                  no-caret
                  :right="$store.state.appConfig.isRTL"
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>

                  <b-dropdown-item
                    variant="primary"
                    href="#"
                    v-if="$can('GetOrderRefundWorkflowHistory', 'Refund')"
                    @click="fetchRefundWorkFLowHistory(props.row)"
                  >
                    <feather-icon class="blue-icon" icon="RefreshCwIcon" />
                    <span class="align-middle ml-50">Approval History</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    variant="primary"
                    href="#"
                    v-if="$can('GetRefundHistory', 'Refund')"
                    @click="refund_History(props.row)"
                  >
                    <feather-icon class="blue-icon" icon="RefreshCwIcon" />
                    <span class="align-middle ml-50">Refund History</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    variant="success"
                    v-if="
                      $can('CompleteAction', 'Refund') &&
                      (props.row.refundStatus === 1 ||
                        props.row.refundStatus === 3)
                    "
                    @click="completeRefundRequest(props.row)"
                  >
                    <feather-icon class="mr-50" icon="CheckIcon" />
                    <span>Complete Refund Request</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    variant="success"
                    v-if="
                      props.row.refundStatus === 3 &&
                      $can('CompleteAction', 'Refund')
                    "
                    @click="resendRefundConfirmationBank(props.row)"
                  >
                    <feather-icon class="mr-50" icon="CheckIcon" />
                    <span>Resend to Bank</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    variant="success"
                    v-if="
                      props.row.refundStatus === 6 &&
                      $can('CompleteAction', 'Refund')
                    "
                    @click="resendRefundConfirmationMerchant(props.row.id)"
                  >
                    <feather-icon class="mr-50" icon="CheckIcon" />
                    <span>Resend to Merchant</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    variant="warning"
                    v-if="
                      props.row.refundStatus != 6 &&
                      $can('CompleteAction', 'Refund')
                    "
                    @click="cancelRefund(props.row)"
                  >
                    <feather-icon class="mr-50" icon="CheckIcon" />
                    <span>Cancel</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-row>
            </span>
          </span>

          <span v-else-if="props.column.field === 'refundStatus'">
            <span>
              <b-badge
                v-if="props.row.refundStatus === 0"
                pill
                variant="secondary"
              >
                Not Requested
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 1"
                pill
                variant="warning"
              >
                Pending
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 2"
                pill
                variant="info"
              >
                Submitted
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 3"
                pill
                variant="success"
              >
                Approved
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 4"
                pill
                variant="primary"
              >
                Sent
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 5"
                pill
                variant="danger"
              >
                Rejected
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 6"
                pill
                variant="info"
              >
                Completed
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 8"
                pill
                variant="light-danger"
                class="text-white"
              >
                Cancelled
              </b-badge>
            </span>
          </span>

          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['5', '10', '15', '30', '50']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </b-card>

    <b-row>
      <b-col>
        <b-modal
          id="modal-filter-orders"
          title="Filter Report"
          ok-title="Search"
          cancel-variant="outline-secondary"
          size="lg"
          @ok="filterOrders"
        >
          <b-form>
            <b-row>
              <b-col cols="6">
                <b-form-group label="Order Id" label-for="orderid">
                  <b-form-input id="orderid" v-model.trim="filterOrderId" />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label="Custom Order Code"
                  label-for="CustomOrderCode"
                >
                  <b-form-input
                    id="CustomOrderCode"
                    v-model="CustomOrderCode"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label="Vendor Txn RefNumber"
                  label-for="vendorTxnRefNumber"
                >
                  <b-form-input
                    id="VendorTxnRefNumber"
                    v-model="VendorTxnRefNumber"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="From Amount" label-for="from-amount">
                  <b-form-input id="from-amount" v-model="filterFromAmount" />
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <b-form-group label="To Amount" label-for="to-amount">
                  <b-form-input id="to-amount" v-model="filterToAmount" />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Ticket Number" label-for="ticket-number">
                  <b-form-input id="ticket-number" v-model="ticketNumber" />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label="Refund Document Number"
                  label-for="refund-document-number"
                >
                  <b-form-input
                    id="refund-document-number"
                    v-model="refundDocumentNumber"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label="Refund Reference Code"
                  label-for="refund-reference-code"
                >
                  <b-form-input
                    id="refund-reference-code"
                    v-model="filterRefundReferenceCode"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label="Refund Merchant Request Code"
                  label-for="refund-merchant-request-code"
                >
                  <b-form-input
                    id="refund-merchant-request-code"
                    v-model="refundMerchantRequestCode"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label="Refund Reference Code From Bank"
                  label-for="refund-reference-code-fromBank"
                >
                  <b-form-input
                    id="refund-reference-code-fromBank"
                    v-model="refundReferenceCodeFromBank"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Refund FOP" label-for="payment-option">
                  <b-form-select
                    id="merchantId"
                    v-model="filterRefundFopId"
                    :options="paymentOptions"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group label="Refund Status" label-for="refund-status">
                  <b-form-select
                    id="refund-status"
                    v-model="filterStatus"
                    :options="refundStatusOptions"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Refunded Date Range"
                  label-for="refunded_date_range"
                >
                  <flat-pickr
                    v-model="refundedDateRange"
                    class="form-control"
                    :config="{ mode: 'range', maxDate: 'today' }"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Refund Request Date Range"
                  label-for="refund-request-date-range"
                >
                  <flat-pickr
                    v-model="refundRequestDateRange"
                    class="form-control"
                    :config="{ mode: 'range', maxDate: 'today' }"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-modal>

        <b-modal
          id="modal-partner-history"
          title="Approval History"
          hide-footer
          cancel-variant="outline-secondary"
          size="xl"
          scrollable
        >
          <b-row>
            <b-col>
              <b-table
                striped
                :items="orderTransactionHistory"
                :fields="orderPartnerHistories"
                caption-top
              />
            </b-col>
          </b-row>
        </b-modal>

        <b-modal
          id="modal-order-history"
          title="Refund History"
          hide-footer
          cancel-variant="outline-secondary"
          size="xl"
          scrollable
        >
          <b-row>
            <b-col>
              <b-table
                striped
                :items="refundHistory"
                :fields="refundHistories"
                caption-top
              >
                <template v-slot:cell(refundStatus)="data">
                  <span>
                    <b-badge
                      v-if="data.item.refundStatus === 0"
                      pill
                      variant="secondary"
                    >
                      Not Requested
                    </b-badge>
                    <b-badge
                      v-else-if="data.item.refundStatus === 1"
                      pill
                      variant="warning"
                    >
                      Pending
                    </b-badge>
                    <b-badge
                      v-else-if="data.item.refundStatus === 2"
                      pill
                      variant="info"
                    >
                      Submitted
                    </b-badge>
                    <b-badge
                      v-else-if="data.item.refundStatus === 3"
                      pill
                      variant="success"
                    >
                      Approved
                    </b-badge>
                    <b-badge
                      v-else-if="data.item.refundStatus === 4"
                      pill
                      variant="primary"
                    >
                      Sent
                    </b-badge>
                    <b-badge
                      v-else-if="data.item.refundStatus === 5"
                      pill
                      variant="danger"
                    >
                      Rejected
                    </b-badge>
                    <b-badge
                      v-else-if="data.item.refundStatus === 6"
                      pill
                      variant="info"
                    >
                      Completed
                    </b-badge>
                  </span>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-modal>

        <b-modal
          id="modal-orderRefund-history"
          title="Order Refund History"
          ok-title="Ok"
          hide-footer
          cancel-variant="outline-secondary"
          size="lg"
          scrollable
        >
          <h3>Refund History for Order Code :{{ selectedOrderRefund }}</h3>
          <hr />
          <b-row>
            <div v-for="item in orderRefundHistory" :key="item.attemptNumber">
              <b-col md="12">
                <b-card-actions
                  :title="item.attemptNumberDescription"
                  action-collapse
                >
                  <b-card-text>
                    <b-table
                      striped
                      :items="item.refundWorkFlowHistories"
                      :fields="orderRefundHistories"
                      caption-top
                    />
                  </b-card-text>
                </b-card-actions>
              </b-col>
            </div>
          </b-row>
        </b-modal>

        <b-modal
          id="modal-complete-refund-request"
          title="Complete Refund Request"
          cancel-variant="outline-secondary"
          size="lg"
          @ok="submitcompleteRefundRequest"
        >
          <form ref="completeform">
            <b-row>
              <b-col md="6">
                <b-form-group label="Refund Reference Code From Bank">
                  <b-form-input
                    id="filterflyGateOrderId-input"
                    v-model="
                      completeRefundRequestfield.RefundReferenceCodeFromBank
                    "
                    :state="
                      completeRefundRequestfield.RefundReferenceCodeFromBank
                        .length > 0
                    "
                    required
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </form>
        </b-modal>

        <b-modal
          id="modal-cancel-refund"
          title="Cancel Refund"
          @ok="submitCancelRefund"
          ok-title="Submit"
          cancel-title="Cancel"
        >
          <form ref="completeform">
            <b-form-group label="Reason for cancellation">
              <b-form-input
                v-model="cancelRefundField.cancelRemark"
                placeholder="Enter reason"
                :state="cancelRefundField.cancelRemark.length > 0"
                required
              ></b-form-input>
            </b-form-group>
          </form>
        </b-modal>
      </b-col>
    </b-row>
    <!-- loadings -->
    <b-overlay :show="isLoading" no-wrap rounded="sm" />
  </div>
</template>

<script>
import {
  BTab,
  BTabs,
  BCard,
  BAvatar,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BFormDatepicker,
  BDropdownItem,
  BRow,
  BCol,
  BForm,
  BLink,
  BTable,
  BCardText,
  BFormCheckbox,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import XlsxSheet from "../../../../node_modules/vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "../../../../node_modules/vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "../../../../node_modules/vue-xlsx/dist/components/XlsxWorkbook";

export default {
  name: "Users",
  components: {
    BTab,
    BTabs,
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormDatepicker,
    flatPickr,
    BForm,
    BLink,
    BTable,
    BCardText,
    BCardActions,
    BFormCheckbox,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      dataFiltered: false,
      selectedOrderRefund: "",
      rows: [],
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      rangeDate: null,
      activeRow: null,
      extendedDate: `${nowDate.getUTCFullYear()}-${
        nowDate.getUTCMonth() + 1
      }-${nowDate.getUTCDate()}`,
      refundRequestDateRange: "",
      refundedDateRange: "",
      VendorTxnRefNumber: "",
      refundRequestedStartDate: "",
      refundedStartDate: "",
      refundRequestedEndDate: "",
      refundedEndDate: "",
      refundReferenceCodeFromBank: "",
      orderAmount: "",
      orderCurrency: "",
      orderCity: "",
      orderCountry: "",
      orderChannel: "",
      selectedOrder: "",
      filterOrderId: "",
      filterRefundFopId: 0,
      filterPaidFopId: 0,
      refundMerchantRequestCode: "",
      filtertrnxDate: "",
      filterPhone: "",
      filterRefundReferenceCode: "",
      filterToAmount: 0,
      filterFromAmount: 0,
      filterStatus: 0,
      CustomOrderCode: "",
      ticketNumber: "",
      refundDocumentNumber: "",
      columns: [
        {
          label: "Refund Requested Date",
          field: "refundRequestedDateString",
        },
        {
          label: "First Name",
          field: "firstName",
        },
        {
          label: "Last Name",
          field: "lastName",
        },
        {
          label: "Custome Order Code",
          field: "customOrderCode",
        },
        {
          label: "Order Id",
          field: "flyGateOrderId",
        },
        {
          label: "Refund FOP",
          field: "refundFOP",
        },
        {
          label: "Refund Reference Code",
          field: "refundReferenceCode",
        },
        {
          label: "Refund Merchant Request Code",
          field: "refundMerchantRequestCode",
        },
        {
          label: "Order Amount",
          field: "orderAmount",
        },
        {
          label: "Refund Requested Amount",
          field: "refundRequestedAmount",
        },
        {
          label: "Vendor TxnRef. Number",
          field: "vendorTxnRefNumber",
        },
        {
          label: "Bank Refund Reference",
          field: "refundReferenceCodeFromBank",
        },
        {
          label: "Refund Document Number",
          field: "refundDocumentNumber",
        },
        {
          label: "Refund Status",
          field: "refundStatus",
        },
        {
          label: "Merchant Name",
          field: "merchantName",
        },

        {
          label: "Action",
          field: "action",
        },
      ],
      sheets: [{ name: "Detail Orders", data: [] }],
      paymentOptions: [{ value: 0, text: "--select Orderd Payment Option--" }],
      paidPaymentOptions: [
        { value: 0, text: "--select Paid Payment Option--" },
      ],
      refundStatusOptions: [
        { value: "0", text: "NotRequested" },
        { value: "1", text: "Pending" },
        { value: "2", text: "Submitted" },
        { value: "3", text: "Approved" },
        { value: "4", text: "Sent" },
        { value: "8", text: "Cancelled" },
        { value: "5", text: "Rejected" },
        { value: "6", text: "Completed" },
      ],
      orderTypeOptions: [
        { value: "0", text: "All" },
        { value: "1", text: "System Initiated" },
        { value: "2", text: "Manual Created" },
        { value: "3", text: "Pay by link" },
      ],
      searchTerm: "",
      editabelData: {},
      refundHistory: [],
      orderTransactionHistory: [],
      orderRefundHistory: [],
      refundHistories: [
        "startDate",
        "refundStatus",
        "description",
        "changedOn",
        "changedBy",
      ],
      orderPartnerHistories: [
        "messageTypeDescription",
        "messageDirectionDescription",
        "paymentOptionDescription",
        "requestMSG",
        "statusDescription",
        "actionTakenBy",
      ],
      // orderRefundHistories: ['level', 'actionDescription', 'transactionDate', 'actionTakenBy'],
      orderRefundHistories: [
        {
          key: "level",
          label: "Level",
        },
        {
          key: "actionDescription",
          label: "Action",
        },
        {
          key: "transactionDate",
          label: "Date",
        },
        {
          key: "actionTakenBy",
          label: "Action By",
        },
      ],
      cancelRefundField: {
        Id: 0,
        cancelRemark: "",
      },
      completeRefundRequestfield: {
        Id: 0,
        RefundReferenceCodeFromBank: "",
        RefundFOP: "",
      },
      referenceNumber: "",
      paidPaymentOption: 0,
      referenceState: null,
      selectedOrderCode: "",
      titleApprove: "",
      amount: 0,
      refundRequest: {
        orderCode: "",
        amount: 0,
        currency: "ETB",
        accountNumber: "",
        isRefundToSeparateAccountNumber: false,
      },
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchallPaymentOptions();
  },
  methods: {
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/FilterMerchantPaymentOptions?filterPaymentOption=0",
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paymentOptions.push({
              value: item.id,
              text: item.name,
            });
            this.paidPaymentOptions.push({
              value: item.paymentOption,
              text: item.name,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterOrders() {
      if (this.refundRequestDateRange !== "") {
        const [orderSttDate, orderEdDate] =
          this.refundRequestDateRange.split(" to ");

        if (this.refundRequestDateRange.includes("to")) {
          this.refundRequestedStartDate = orderSttDate;
          this.refundRequestedEndDate = orderEdDate;
        } else {
          this.refundRequestedStartDate = this.refundRequestDateRange;
          this.refundRequestedEndDate = this.refundRequestDateRange;
        }
      }

      if (this.refundedDateRange !== "") {
        const [refundedDateSttDate, refundedDateEdDate] =
          this.refundedDateRange.split(" to ");

        if (this.refundedDateRange.includes("to")) {
          this.refundedStartDate = refundedDateSttDate;
          this.refundedEndDate = refundedDateEdDate;
        } else {
          this.refundedStartDate = this.refundedDateRange;
          this.refundedEndDate = this.refundedDateRange;
        }
      }

      const url = `/Order/api/V1.0/Refund/GetOverAllRefundRequests?flyGateOrderId=${this.filterOrderId}
      &vendorTxnRefNumber=${this.VendorTxnRefNumber}&customOrderCode=${this.CustomOrderCode}
      &refundReferenceCode=${this.filterRefundReferenceCode}&fromRequestedAmount=${this.filterFromAmount}
      &toRequestedAmount=${this.filterToAmount}&refundedFOP=${this.filterRefundFopId}
      &refundMerchantRequestCode=${this.refundMerchantRequestCode}&refundStatus=${this.filterStatus}
      &fromRefundRequestedDate=${this.refundRequestedStartDate}&toRefundRequestedDate=${this.refundRequestedEndDate}
      &refundReferenceCodeFromBank=${this.refundReferenceCodeFromBank}
      &ticketNumber=${this.ticketNumber}&refundDocumentNumber=${this.refundDocumentNumber}
      &fromRefundedDate=${this.refundedStartDate}&toRefundedDate=${this.refundedEndDate}`;

      // Api call
      this.isLoading = true;
      axios
        .get(url)
        .then((res) => {
          this.dataFiltered = true;
          this.rows = res.refundRequests;
          this.sheets[0].data = [];
          res.refundRequests.map((m) => {
            this.sheets[0].data.push({
              "Refund Requested Date": m.refundRequestedDateString,
              "First Name": m.firstName,
              "Last Name": m.lastName,
              "Custom Order Code": m.customOrderCode,
              "Fly Gate Order ID": m.flyGateOrderId,
              "Refunded FOP": this.paymentOptions.filter(
                (f) => f.value == m.refundFOP,
              )[0].text,
              "Refund Reference Code": m.refundReferenceCode,
              "Refund Merchant Request Code": m.refundMerchantRequestCode,
              "Ticket Number": m.originalTicketNumber,
              "Refund Document Number": m.refundDocumentNumber,
              "Order Amount": m.orderAmount,
              "Refund Requested Amount": m.refundRequestedAmount,
              "Vendor TxnRef. Number": m.vendorTxnRefNumber,
              "Bank Refund Reference": m.refundReferenceCodeFromBank,
              "Refund Status":
                m.refundStatus == 0
                  ? "Refund Not Requested"
                  : m.refundStatus == 1
                  ? "Refund Pending"
                  : m.refundStatus == 2
                  ? "Refund Submitted"
                  : m.refundStatus == 3
                  ? "Refund Approved"
                  : m.refundStatus == 4
                  ? "Refund Sent"
                  : m.refundStatus == 5
                  ? "Refund Rejected"
                  : m.refundStatus == 6
                  ? "Refund Completed"
                  : null,
              "Merchant Name": m.merchantName,
            });
          });
          this.isLoading = false;
          this.refundRequestedStartDate = "";
          this.refundRequestedEndDate = "";
          this.refundedStartDate = "";
          this.refundedEndDate = "";
          this.refundRequestDateRange = "";
          this.refundedDateRange = "";
        })
        .catch((res) => {
          console.log(res);
          this.isLoading = false;
          this.rows = [];
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.refundRequestedStartDate = "";
          this.refundRequestedEndDate = "";
          this.refundedStartDate = "";
          this.refundedEndDate = "";
          this.refundRequestDateRange = "";
          this.refundedDateRange = "";
        });
    },
    refund_History(row) {
      // Api call
      this.isLoading = true;
      axios
        .get(`/Order/api/V1.0/Refund/GetRefundHistory?RequestId=${row.id}`)
        .then((res) => {
          console.log(res);
          this.refundHistory = res.refundHistory;
          this.$bvModal.show("modal-order-history");
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk(res.data.message, {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        });
    },
    fetchRefundWorkFLowHistory(row) {
      // Api call
      this.isLoading = true;
      axios
        .get(
          `/Order/api/V1.0/Refund/GetOrderRefundWorkflowHistory?refundRequestId=${row.id}`,
        )
        .then((res) => {
          console.log(res);
          this.orderTransactionHistory = res.refundWorkFlowHistories;
          this.$bvModal.show("modal-partner-history");
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk(res.data.message, {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        });
    },
    completeRefundRequest(row) {
      this.completeRefundRequestfield.Id = row.id;
      this.completeRefundRequestfield.RefundFOP = this.paymentOptions.filter(
        (f) => f.text == row.paidFOP,
      );
      this.completeRefundRequestfield.RefundFOP =
        this.completeRefundRequestfield.RefundFOP[0].value.toString();
      this.$bvModal.show("modal-complete-refund-request");
    },
    submitcompleteRefundRequest(bvModalEvent) {
      bvModalEvent.preventDefault();
      if (this.$refs.completeform.checkValidity()) {
        this.$nextTick(() => {
          this.$bvModal.hide("modal-complete-refund-request");
        });

        this.$bvModal
          .msgBoxConfirm(
            `Are You Sure You Want to Complete the Refund Request?`,
            {
              title: "Warning",
              size: "sm",
              buttonSize: "sm",
              headerBgVariant: "warning",
              cancelTitle: "NO",
              cancelVariant: "warning",
              okVariant: "primary",
              okTitle: "YES",
              footerClass: "p-2",
              hideHeaderClose: true,
              centered: true,
            },
          )
          .then((value) => {
            if (value) {
              this.isLoading = true;
              this.$store.dispatch(
                "config/getActionPrivilege",
                "Refund-CompleteAction",
              );
              axios
                .post(
                  `Order/api/V1.0/Refund/RefundCompletedAction`,
                  this.completeRefundRequestfield,
                )
                .then((res) => {
                  this.isLoading = false;
                  this.$bvModal.msgBoxOk("Data was submitted successfully", {
                    title: "Confirmation",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  });
                  window.location.reload();
                })
                .catch((res) => {
                  this.isLoading = false;
                  console.log(res);
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: `${res.data.message}`,
                    },
                  });
                  // this.$refs.loginForm.setErrors(error)
                });
            }
          });
      }
    },
    resendRefundConfirmationBank(row) {
      this.$bvModal
        .msgBoxConfirm(` You Want to send refund confirmation to Bank?`, {
          title: "Are You Sure",
          size: "sm",
          buttonSize: "sm",
          headerBgVariant: "warning",
          cancelTitle: "NO",
          cancelVariant: "warning",
          okVariant: "primary",
          okTitle: "YES",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isLoading = true;
            this.$store.dispatch(
              "config/getActionPrivilege",
              "Refund-CompleteAction",
            );
            axios
              .get(
                `/Order/api/V1.0/Refund/ResendRefundRequestToBank?merchantRefundReferenceCode=${row.refundMerchantRequestCode}`,
              )
              .then((res) => {
                this.isLoading = false;
                this.$swal({
                  icon: "info",
                  title: res.message,
                  customClass: {
                    confirmButton: "btn btn-info",
                  },
                }).then((res) => {
                  window.location.reload();
                });
              })
              .catch((res) => {
                this.isLoading = false;
                console.log(res);
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: `${res.data.message}`,
                  },
                });
                // this.$refs.loginForm.setErrors(error)
              });
          }
        });
    },
    resendRefundConfirmationMerchant(id) {
      this.$bvModal
        .msgBoxConfirm(` You Want to send refund confirmation to Merchants?`, {
          title: "Are You Sure",
          size: "sm",
          buttonSize: "sm",
          headerBgVariant: "warning",
          cancelTitle: "NO",
          cancelVariant: "warning",
          okVariant: "primary",
          okTitle: "YES",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isLoading = true;
            this.$store.dispatch(
              "config/getActionPrivilege",
              "Refund-CompleteAction",
            );
            axios
              .get(`/Order/api/V1.0/Refund/ResendRefundConfirmation?Id=${id}`)
              .then((res) => {
                this.isLoading = false;
                this.$bvModal.msgBoxOk(
                  "Refund Confirmation Resend successfully",
                  {
                    title: "Confirmation",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  },
                );
                window.location.reload();
              })
              .catch((res) => {
                this.isLoading = false;
                console.log(res);
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: `${res.data.message}`,
                  },
                });
                // this.$refs.loginForm.setErrors(error)
              });
          }
        });
    },
    cancelRefund(row) {
      this.cancelRefundField.Id = row.id;
      this.$bvModal.show("modal-cancel-refund");
    },
    submitCancelRefund(bvModalEvent) {
      if (this.$refs.completeform.checkValidity()) {
        this.$nextTick(() => {
          this.$bvModal.hide("modal-complete-refund-request");
        });
        this.isLoading = true;
        this.$store.dispatch(
          "config/getActionPrivilege",
          "Refund-CompleteAction",
        );
        axios
          .post(`/Order/api/V1.0/Refund/CancelRefund`, this.cancelRefundField)
          .then((res) => {
            this.isLoading = false;
            this.$swal({
              icon: "success",
              title: res.message,
              customClass: {
                confirmButton: "btn btn-success",
              },
            }).then((res) => {
              this.fetchRefundRequests();
              this.cancelRefundField.cancelRemark = "";
            });
          })
          .catch((res) => {
            this.isLoading = false;
            this.cancelRefundField.cancelRemark = "";
            console.log(res);
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: `${res.data.message}`,
              },
            });
            // this.$refs.loginForm.setErrors(error)
          });
      }
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.referenceState = valid;
      return valid;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
